import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import type { TextualHeaderType } from '../segyHelpers'
import css from './Setup.css'

export const TextualHeaderTable: FC<{ textualHeader?: TextualHeaderType }> = ({
  textualHeader,
}) => {
  return (
    <div className={css.codeFrameTextHeader}>
      {textualHeader?.lines.map((line, index) => {
        return (
          <div key={index} className={css.codeFrameTextWrapper}>
            <Text size="xs" font="mono" view="ghost">
              {index + 1}
            </Text>
            <Text size="xs" font="mono" view="secondary" className={css.codeFrameTextHeaderText}>
              {line}
            </Text>
          </div>
        )
      })}
    </div>
  )
}
